

export const appealStatuses = {
    pending: 'pending',
    approved: 'approved', // success
    rejected: 'rejected', // error
    executed: 'executed' // done
};
export const chargebackStatuses = {
    pending: 'pending',
    accepted: 'accepted',
    rejected: 'rejected'
};
export const fraudStatuses = {
    pending: 'pending',
    accepted: 'accepted',
    rejected: 'rejected'
};
export const approvalStates = {
    pending: 'pending',
    approved: 'approved',
    rejected: 'rejected'
};

export const callbackStatuses = {
    init: 'init',
    retry: 'retry',
    success: 'success',
    failed: 'failed'
};

export const cryptoDirections = {
    in: 'in',
    out: 'out'
};

export const dimensions = {
    percent: 'percent',
    fixed: 'fixed'
};

export const directions = {
    deposit: 'deposit',
    withdrawal: 'withdrawal'
};

export const instanceStates = {
    new: 'new',
    initialize: 'initialize',
    refused: 'refused',
    sum_blocked: 'sum_blocked',
    awaiting_3ds: 'awaiting_3ds',
    processed: 'processed',
    partially_refunded: 'partially_refunded',
    refunded: 'refunded',
    cancelled: 'cancelled',
    awaiting_processing: 'awaiting_processing',
    awaiting_withdraw: 'awaiting_withdraw',
    withdrawed: 'withdrawed',
    withdraw_cancelled: 'withdraw_cancelled',
    awaiting_confirmation: 'awaiting_confirmation'
};

export const orderStatuses = {
    open: 'open',
    initialize: 'initialize',
    payment_initiated: 'payment_initiated',
    payment_final: 'payment_final',
    payment_success: 'payment_success',
    expired: 'expired',
    fraud: 'fraud',
    refused: 'refused',
    processed: 'processed',
    cancelled: 'cancelled',
    awaiting_processing: 'awaiting_processing',
    error: 'error'
};

export const processingStates = {
    pending: 'pending',
    processed: 'processed',
    rejected: 'rejected'
};

export const refundStates = {
    initialize: 'initialize',
    processed: 'processed',
    refused: 'refused'
};

export const sexes = {
    male: 'male',
    female: 'female',
    other: 'other'
};

export const terminalFlags = {
    payment: 'payment',
    payout: 'payout',
    p2p: 'p2p'
};

export const costType = {
    merchant: 'merchant',
    gateway: 'gateway',
    agent: 'agent'
};
export const cascadingStatuses = {
    cascade_current: 'cascade_current',
    cascade_cancelled: 'cascade_cancelled',
    cascade_final: 'cascade_final'
};

export const withdrawalKinds = {
    revenue: 'revenue',
    expenses: 'expenses'
};

export const calculationTypes = {
    included_in_price: 'included_in_price',
    on_top_of_price: 'on_top_of_price',
    payout_included_in_price: 'payout_included_in_price',
    payout_on_top_of_price: 'payout_on_top_of_price',
    refund: 'refund',
    chargeback: 'chargeback',
    fraud: 'fraud',
    decline: 'decline',
    agent_type: 'agent_type'
};
//  "processedStatuses": "charged,complete,success,processed",
export const processedStatuses = {
    charged: 'charged',
    complete: 'complete',
    success: 'success',
    processed: 'processed'
};
//public enum ValidationTaskStatus {
//    pending, ready, rejected
// }
export const validationTaskStatuses = {
    pending: 'pending',
    ready: 'ready',
    rejected: 'rejected'
};
// public enum FiltersUserStatus {
//     primary,
//     secondary,
//     banned,
//     vip
// }

export const filtersUserStatuses = {
    primary: 'primary',
    secondary: 'secondary',
    banned: 'banned',
    vip: 'vip'
};
//filtersIpListStatuses
// approved, pending, primary, white
export const filtersIpListStatuses = {
    approved: 'approved',
    pending: 'pending',
    primary: 'primary',
    white: 'white'
};

export const walletKycStatuses = {
    pending: 'pending',
    approved: 'approved',
    rejected: 'rejected',
    under_review: 'under_review'
};

export const walletPinCodeTypes = {
    registration: 'registration',
    forgot_password: 'forgot_password',
    login: 'login'
};

export const walletNotificationStatuses = {
    new: 'NEW',
    sent: 'SENT',
    opened: 'OPENED',
    failed: 'FAILED',
    partial: 'PARTIAL',
    cancelled: 'CANCELLED'
};

export const walletNotificationChannels = {
    email: 'email',
    sms: 'sms',
    push: 'push'
};

export const walletNotificationCategories = {
    transactional: 'transactional',
    security: 'security',
    referral: 'referral',
    marketing: 'marketing'
};

// Mirror of backend enum cabinet.db.notifications.NotificationName.
// New values must be added on both sides.
export const walletNotificationNames = {
    deposit_completed: 'deposit_completed',
    withdrawal_pending: 'withdrawal_pending',
    withdrawal_completed: 'withdrawal_completed',
    withdrawal_rejected: 'withdrawal_rejected',
    referral_reward_claimed: 'referral_reward_claimed',
    security_new_device_login: 'security_new_device_login'
};

export const walletAccountStatuses = {
    active: 'active',
    blocked: 'blocked',
    closed: 'closed'
};

export const walletTransferDirections = {
    deposit: 'deposit',
    withdrawal: 'withdrawal'
};

export const walletTransferMethods = {
    sbp: 'sbp',
    card: 'card',
    internal: 'internal',
    referral: 'referral'
};

export const walletTransferStatuses = {
    pending: 'pending',
    processing: 'processing',
    completed: 'completed',
    failed: 'failed',
    rejected: 'rejected',
    cancelled: 'cancelled'
};

export const cryptoTopupStatuses = {
    unverified: 'unverified',
    aml_requested: 'aml_requested',
    aml_completed: 'aml_completed',
    fiat_credited: 'fiat_credited'
};

export const riskLevels = {
    none: 'none',
    low: 'low',
    medium: 'medium',
    high: 'high',
    severe: 'severe',
    undefined: 'undefined'
};

export const partnersReferralStatuses = {
    pending: 'pending',
    activated: 'activated',
    blocked: 'blocked'
};

export const partnersRewardStatuses = {
    pending: 'pending',
    available: 'available',
    claimed: 'claimed',
    reversed: 'reversed'
};

export const partnersPayoutStatuses = {
    processing: 'processing',
    completed: 'completed',
    failed: 'failed'
};

export const partnersTransferKinds = {
    transfer: 'transfer',
    crypto_topup: 'crypto_topup',
    crypto_withdrawal: 'crypto_withdrawal'
};

